// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3L2ld","rootCenter":"LoadMoreObserver_rootCenter__1wwLK","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1i8oB"};